import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { normalizeTextField } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (messages) => {
  const textField = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.REQUIRED);
  const requiredTextField = textField.required(messages.REQUIRED);
  const optionalTextField = yup
    .string()
    .transform(normalizeTextField)
    .nullable();
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.STREET]: yup.object().shape({
        value: requiredTextField,
      }),
      [CONTACT_POINT_SYSTEM.ADDRESS_LOCATION]: yup.object().shape({
        value: optionalTextField,
      }),
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: requiredTextField,
      }),
      [CONTACT_POINT_SYSTEM.CITY]: yup.object().shape({
        value: requiredTextField,
      }),
      [CONTACT_POINT_SYSTEM.COMPLEMENT]: yup.object().shape({
        value: optionalTextField,
      }),
      [CONTACT_POINT_SYSTEM.RESIDENCE]: yup.object().shape({
        value: optionalTextField,
      }),
    }),
  });
};

export default validation;
